// src/sagas/blogSaga.js
import { call, put, takeLatest } from "redux-saga/effects";
import {
  FETCH_BLOGS_REQUEST,
  SAVE_BLOG_REQUEST,
  DELETE_BLOG_REQUEST,
} from "../actions/types";
import {
  fetchBlogsSuccess,
  fetchBlogsFailure,
  saveBlogSuccess,
  saveBlogFailure,
  deleteBlogSuccess,
  deleteBlogFailure,
  fetchBlogsRequest,
} from "../actions/blogActions";
import {
  fetchBlogPostsFromApi,
  saveLibraryCardToApi,
  deleteLibraryCardFromApi,
} from "../apis/libraryCardApi";

function* fetchBlogsSaga(action) {
  try {
    const raw = yield call(fetchBlogPostsFromApi, action.payload);
    const blogs = raw.map((item) => {
      try {
        const data = typeof item.payload === "string" ? JSON.parse(item.payload) : item.payload || {};
        return { ...item, ...data };
      } catch {
        return item;
      }
    });
    yield put(fetchBlogsSuccess(blogs));
  } catch (err) {
    console.error("blogSaga - fetchBlogs error:", err);
    yield put(fetchBlogsFailure(err.message));
  }
}

function* saveBlogSaga(action) {
  try {
    yield call(saveLibraryCardToApi, action.payload);
    yield put(saveBlogSuccess(action.payload));
    // Refresh list after save
    yield put(fetchBlogsRequest({ tenantId: action.payload.tenantId }));
  } catch (err) {
    console.error("blogSaga - saveBlog error:", err);
    yield put(saveBlogFailure(err.message));
  }
}

function* deleteBlogSaga(action) {
  try {
    yield call(deleteLibraryCardFromApi, {
      tenantId: action.payload.tenantId,
      entityType: "BLOGPOST",
      entityId: action.payload.entityId,
    });
    yield put(deleteBlogSuccess(action.payload));
    // Refresh list after delete
    yield put(fetchBlogsRequest({ tenantId: action.payload.tenantId }));
  } catch (err) {
    console.error("blogSaga - deleteBlog error:", err);
    yield put(deleteBlogFailure(err.message));
  }
}

export default function* blogSaga() {
  yield takeLatest(FETCH_BLOGS_REQUEST, fetchBlogsSaga);
  yield takeLatest(SAVE_BLOG_REQUEST, saveBlogSaga);
  yield takeLatest(DELETE_BLOG_REQUEST, deleteBlogSaga);
}
